import axios from "axios";
import BubbleService from "../BubbleService";
import quiz1 from "@/assets/quiz/1.json";
import quiz2 from "@/assets/quiz/2.json";
import quiz3 from "@/assets/quiz/3.json";
import quiz4 from "@/assets/quiz/4.json";
import quiz5 from "@/assets/quiz/5.json";
import quiz6 from "@/assets/quiz/6.json";

import quiz7 from "@/assets/quiz/7.json";
import quiz8 from "@/assets/quiz/8.json";
import quiz9 from "@/assets/quiz/9.json";
import quiz10 from "@/assets/quiz/10.json";
import quiz11 from "@/assets/quiz/11.json";
import quiz12 from "@/assets/quiz/12.json";
import quiz13 from "@/assets/quiz/13.json";
import quiz14 from "@/assets/quiz/14.json";
import quiz15 from "@/assets/quiz/15.json";
import quiz16 from "@/assets/quiz/16.json";

class ScoreService extends BubbleService {
    private icon_url_list = [
        quiz7,quiz8,quiz9,quiz10,quiz11,quiz12,quiz13,quiz14,quiz15,quiz16,
        quiz1,quiz2,quiz3,quiz4,quiz5,quiz6
    ];

    constructor() {
        super();
    }

    getTestIcon = (answers: any[]) => {
        let icon = this.icon_url_list[Math.ceil(answers.length/10 +1)]
        console.log(icon)
        console.log(Math.ceil(answers.length/8 +1))
        return icon;
    };

    getPsychometricQuestions = async () => {
        const pageOne:any = await this.getObj("Questionnaire");
        const pageTwo:any = await this.getObj("Questionnaire?cursor=100");
        let questions = pageOne.results.concat(pageTwo.results);
        questions.sort(this.shuffle);
        return questions;
    };

    shuffle() {
        return 0.5 - Math.random();
    }
}

export default ScoreService;
